import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import InnerAccordion from '@hkm/components/TaskManagement/TaskPreview/LinkedObject/shared/InnerAccordion/InnerAccordion';
import SpecialNeeds from '@hkm/components/TaskManagement/TaskPreview/LinkedObject/shared/SpecialNeeds/SpecialNeeds';
import VipAndMember from '@hkm/components/TaskManagement/TaskPreview/LinkedObject/shared/VipAndMember/VipAndMember';

import { ReservationAccompanyingGuestDashboardItem } from '@ac/library-api';
import { AcFormElement } from '@ac/mobile-components/dist/components/form-element';
import { AcIndicator } from '@ac/mobile-components/dist/components/indicator';
import { AcText } from '@ac/mobile-components/dist/components/text';
import { Color, Icon, TextSize } from '@ac/mobile-components/dist/enums';

interface ComponentProps {
  guest: ReservationAccompanyingGuestDashboardItem;
  index: number;
}

const ReservationAccompanyingGuest = (props: ComponentProps) => {
  const { guest, index } = props;
  const { t } = useTranslation();
  const requireAccordion =
    guest.hasDisability ||
    !!guest.vipStatusCode ||
    !!guest.activeMembershipLevelCodes.length;

  const guestInfo = useMemo(
    () => (
      <>
        <AcText
          size={TextSize.Main2}
          className="ac-spacing-right-sm"
          testSelector={`task-accompanying-guest-name-${index}`}
        >
          {guest.formattedName}
        </AcText>

        {(!!guest.vipStatusCode ||
          !!guest.activeMembershipLevelCodes.length) && (
          <AcIndicator
            className="ac-spacing-right-sm"
            icon={Icon.Vip}
            backgroundColor={Color.Warning}
            testSelector={`task-accompanying-guest-vip-indicator-${index}`}
          />
        )}
        {guest.hasDisability && (
          <AcIndicator
            icon={Icon.Disability}
            backgroundColor={Color.Alert}
            testSelector={`task-accompanying-guest-disability-indicator-${index}`}
          />
        )}
      </>
    ),
    [guest]
  );

  return (
    <>
      {requireAccordion ? (
        <InnerAccordion header={guestInfo} id={guest?.id || ''}>
          {(!!guest.vipStatusCode ||
            !!guest.activeMembershipLevelCodes.length) && (
            <AcFormElement
              label={t(
                'TASK_MANAGEMENT.TASK_PREVIEW.AREA.COMMON.VIP_AND_MEMBERSHIP'
              )}
              className="ac-spacing-top-md"
            >
              <VipAndMember
                vipStatusCode={guest.vipStatusCode}
                memberships={guest.activeMembershipLevelCodes}
              />
            </AcFormElement>
          )}
          {guest.hasDisability && (
            <AcFormElement
              label={t(
                'TASK_MANAGEMENT.TASK_PREVIEW.AREA.COMMON.SPECIAL_NEEDS'
              )}
            >
              <SpecialNeeds disabilityCodes={guest.disabilityCodes} />
            </AcFormElement>
          )}
        </InnerAccordion>
      ) : (
        guestInfo
      )}
    </>
  );
};

export default ReservationAccompanyingGuest;



// WEBPACK FOOTER //
// ./src/components/TaskManagement/TaskPreview/LinkedObject/shared/ReservationAccompanyingGuest/ReservationAccompanyingGuest.tsx